import React, { memo } from 'react';

import Responsive from '@/components/Responsive';

import { BaseSortMenuItem, SortMenuItemProps } from '../SortMenuItems/types';
import SortMenuItemDesktop from './index.desktop';
import SortMenuItemMobile from './index.mobile';

function SortMenuItem<T extends BaseSortMenuItem>(props: SortMenuItemProps<T>) {
  return (
    <Responsive>
      <Responsive.Default>
        <SortMenuItemDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <SortMenuItemMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default memo(SortMenuItem) as typeof SortMenuItem;
